import { Box } from '@mui/material'
import { ArrowRight2 } from 'iconsax-react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { customerScalling, isEntryPoint, isScaling } from '../lib/utils'
import { RootState } from '../redux/deviceStatistics/types'

interface leftArrayProps {
  id: number
  name: string
  title: string
  description: string
  url: string
}

interface SettingLeftSidebarProps {
  setSelectedOptionId?: any
}

const SettingLeftSidebar = ({ setSelectedOptionId }: SettingLeftSidebarProps) => {
  const defaultUserData = useSelector((state: RootState) => state.user)
  const navigate = useNavigate()
  const location = useLocation()
  const { data } = location.state ?? {}
  const leftArray: leftArrayProps[] =
    isScaling && location.pathname.includes('/notifications')
      ? [
          {
            id: 1,
            name: 'Gateways Go Offline',
            title: 'Gateways Go Offline',
            description: 'Gateways Go Offline',
            url: '/notifications'
          }
        ]
      : [
          {
            id: 1,
            name: 'Firmware Upgrades',
            title: 'Firmware Upgrades',
            description: 'Firmware Upgrades',
            url: '/groups'
          },
          {
            id: 2,
            name: 'Agent Management',
            title: 'Agent Management',
            description: 'Agent Management',
            url: '/Agent'
          }
        ]

  const filterArray =
    customerScalling || isEntryPoint
      ? defaultUserData?.isPlatformSupportAdmin
        ? leftArray.filter(res => res.id !== 1)
        : defaultUserData?.isMSOPortalAdmin || defaultUserData?.isMSOSuperAdmin
        ? leftArray.filter(res => res.id !== 2)
        : leftArray
      : leftArray.filter(res => res.id !== 2)

  const [selected, setSelected] = useState(1)

  useEffect(() => {
    setSelected(location.pathname.includes('/Agent') || defaultUserData?.isPlatformSupportAdmin ? 2 : 1)
  }, [defaultUserData, location.pathname])

  return (
    <Box
      className='custom_main_wrapper !items-start !pe-0'
      sx={{ height: { sm: 'auto', md: '80vh' }, overflowY: 'auto' }}
    >
      <Box
        className='customer_header_wrapper custome-padding flex lg:!flex-col flex-row gap-1 lg:justify-between pr-[20px] !w-full'
        sx={{
          overflowX: { sm: 'auto', lg: 'unset' },
          whiteSpace: 'nowrap'
        }}
      >
        {filterArray &&
          filterArray?.map((res: leftArrayProps, key: number) => {
            return (
              <div
                className={`flex  justify-between p-2 cursor-pointer lg:!w-full w-[180px] flex-shrink-0 ${
                  res.id === selected ? `active-bg-${process.env.REACT_APP_COLOR} rounded` : 'bg-white'
                }`}
                key={key}
                onClick={() => {
                  setSelected(res.id || 1)
                  setSelectedOptionId?.(res?.id || 1)
                  navigate(res.url, { state: { data: data } })
                }}
              >
                <div className='text-base font-bold'> {res?.name}</div>
                <ArrowRight2 />
              </div>
            )
          })}
      </Box>
    </Box>
  )
}

export default SettingLeftSidebar
